import {
	request,
} from '@/api/_service.js'

/**
 * @description 获得我的概览
 * @param {Object} data 登录携带的信息
 */
export function GET_MINE_GENERALS(params) {
	// 接口请求
	return request({
		url: '/generals/mine',
		method: 'get',
		params
	})
}

/**
 * @description 获得公共概览
 * @param {Object} data 登录携带的信息
 */
export function GET_SHARED_GENERALS(params) {
	// 接口请求

	return request({
		url: '/generals/search/findAllByShared',
		method: 'get',
		params: {
			...params,
			shared: true
		}
	})
}

/**
 * @description 获得公共概览
 * @param {Object} data 登录携带的信息
 */
export function SEARCH_SHARED_GENERALS(params) {
	// 接口请求
	if (params.search !== undefined && params.search !== '') {
		return request({
			url: '/generals/search/findAllBySharedAndNameContains',
			method: 'get',
			params: {
				...params,
				shared: true,
				search: params.search
			}
		})
	} else {
		return GET_SHARED_GENERALS(params)
	}
}

/**
 * @description 获得公共概览
 * @param {Object} data 登录携带的信息
 */
export function GET_SYSTEM_GENERALS(params) {
	// 接口请求

	return request({
		url: '/generals/search/findAllBySystem',
		method: 'get',
		params: {
			...params,
			system: true
		}
	})
}


/**
 * @description 获得我的概览
 * @param {Object} data 登录携带的信息
 */
export function ADD_GENERAL(data) {
	// 接口请求
	return request({
		url: '/generals',
		method: 'post',
		data
	})
}

/**
 * @description 通过指定分析模型详情获取初始化信息
 * @param {Object} data 登录携带的信息
 */
export function MODULE_TEST_INIT({
	domain,
	data,
	params = {},
}) {
	return request({
		url: `/${domain}/init`,
		method: 'post',
		data,
		params,
	})
}

/**
 * @description 通过指定分析模型详情查询数据
 * @param {Object} data 登录携带的信息
 */
export function MODULE_TEST_QUERY({
	domain,
	params = {},
	data
}) {
	return request({
		url: `/${domain}/query`,
		method: 'post',
		data,
		params,
	})
}

/**
 * @description 通过指定分析模型详情获取初始化信息
 * @param {Object} data 登录携带的信息
 */
export function MODULE_ID_INIT({
	domain,
	id,
	params = {},
}) {
	return request({
		url: `/${domain}/${id}/init`,
		params,
		method: 'get',
	})
}

/**
 * @description 通过指定分析模型详情查询数据
 * @param {Object} data 登录携带的信息
 */
export function MODULE_ID_QUERY({
	domain,
	id,
	params = {},
}) {
	return request({
		url: `/${domain}/${id}/query`,
		params,
		method: 'get',
	})
}

/**
 * @description 通过获取我的分析模型记录
 * @param {Object} data 登录携带的信息
 */
export function MODULE_MINE({
	domain,
	params
}) {
	return request({
		url: `/${domain}/mine`,
		method: 'get',
		params
	})
}

/**
 * @description 通过指定分析模型详情查询数据
 * @param {Object} data 登录携带的信息
 */
export function MODULE_POST({
	domain,
	data
}) {
	return request({
		url: `/${domain}`,
		method: 'post',
		data
	})
}
